import React from 'react'
import ChooseTipoDeRecebimentoDialog from './chooseTipoDeRecebimentoDialog'
import { Dropdown } from 'primereact/dropdown'
import TooltipButton from '../tooltipButton'
import TiposDeRecebimentoService from '../../app/service/tiposDeRecebimentoService'
import HandleErrorService from '../../app/service/handleErrorService'
import CadastrarTipoDeRecebimentoSimplesDialog from './cadastrarTipoDeRecebimentoSimplesDialog'
import ConstantsUtil from '../../context/constantsUtil'

class InputChooseTipoDeRecebimento extends React.Component {

    constructor(){
        super()
        this.tiposDeRecebimentoService = new TiposDeRecebimentoService()

    }

    state = {

        chooseTipoDeRecebimentoDialogVisible: false,

        selectedTipoDeRecebimentoIdSimpleView: null,
        tiposDeRecebimentoSelectList: [],
        tipoDeRecebimentoList: [],

        displayCadastroTipoDeRecebimentoDialog: false,



    }

    componentDidMount(){

        if(this.props.simpleView){
            // console.log("componentDidMount: ", this.props.tipoDeRecebimentoList)
            this.createTiposDeRecebimentoSelectList(this.props.tipoDeRecebimentoList)

        }

        else if(this.props.renderDialogOnMount){
            this.setState({chooseTipoDeRecebimentoDialogVisible: true})
        }
    }

    createTiposDeRecebimentoSelectList = (tipoDeRecebimentoList) => {

        if(!tipoDeRecebimentoList || tipoDeRecebimentoList.length == 0){
            this.searchTiposDeRecebimento()
            return;
        }
        else{

            this.setState({tipoDeRecebimentoList})

            let tiposDeRecebimentoSelectList = tipoDeRecebimentoList.map(tipoDeRecebimento => ({
                label: `${tipoDeRecebimento.numeroDeChamada} - ${tipoDeRecebimento.nomeTipoDeRecebimento}`,
                value: tipoDeRecebimento.id
            }))

            this.setState({tiposDeRecebimentoSelectList})
            this.setaTipoDeRecebimentoInicial(tipoDeRecebimentoList)
        }


    }

    setaTipoDeRecebimentoInicial = (tiposDeRecebimentoList) => {
        // console.log("setaTipoDeRecebimentoInicial: ", this.props.selectedTipoDeRecebimento)
        if(this.props.selectedTipoDeRecebimento){
            const selected = tiposDeRecebimentoList.find(tipoDeRecebimento => tipoDeRecebimento.id === this.props.selectedTipoDeRecebimento.id);
            // console.log("selected: ", selected)
            this.setState({selectedTipoDeRecebimentoIdSimpleView: selected.id})
        }
    }

    clearSelectedTipoDeRecebimentoIdSimpleView = () => {
        this.setState({selectedTipoDeRecebimentoIdSimpleView: null})
    }

    searchTiposDeRecebimento = () => {
        this.tiposDeRecebimentoService.search(true)
        .then(response => {
            let list = response.data
            this.setState({tipoDeRecebimentoList: list})
            this.createTiposDeRecebimentoSelectList(list)
        })
        .catch(error => {
            HandleErrorService.handleError(error)
            console.log("error: ", error)
        })
        .finally(() => {
        })
    }

    hideTipoDeRecebimentoDialog = () => {
        this.setState({chooseTipoDeRecebimentoDialogVisible: false})

        if(this.props.hideDialog){
            this.props.hideDialog()
        }
    }

    handleSelectionTipoDeRecebimentoChange = async (tipoDeRecebimento) => {
        const label = tipoDeRecebimento.nomeTipoDeRecebimento + " - Natureza " + tipoDeRecebimento.natureza
        this.props.handleSelectionTipoDeRecebimentoChange(tipoDeRecebimento, label)
    }

    handleKeyPress = async (e) => {
        if (e.key === "Enter") {
            this.inputClick()
          }
    }

    inputClick = () => {
        this.setState({chooseTipoDeRecebimentoDialogVisible: true})
        
        // if(this.props.onRenderDialog){
        //     this.props.onRenderDialog()
        // }

    }

    generateLabel = () => {
        var label = "Tipo de Recebimento"

        if(this.props.optional){
            label+=" (Opcional)"
        }

        return label
    }

    
    handleTipoDeRecebimentoChangeSelectList = (event) => {

        // console.log("handleTipoDeRecebimentoChangeSelectList: ", this.state.tipoDeRecebimentoList)

        this.setState({selectedTipoDeRecebimentoIdSimpleView: event.value})
        let selectedTipoDeRecebimento = this.state.tipoDeRecebimentoList.find(tipoDeRecebimento => tipoDeRecebimento.id === event.value);
        // console.log("selectedTipoDeRecebimento: ", selectedTipoDeRecebimento)
        this.handleSelectionTipoDeRecebimentoChange(selectedTipoDeRecebimento)
    }

    hideCreateTipoDeRecebimentoDialog = () => {
        this.setState({
            displayCadastroTipoDeRecebimentoDialog: false,
        })
    }

    render(){

        const handleView = () => {
            if(this.props.simpleView){
                return (
                    <>
                        {renderSelect()}
                    </>
                )
            }

            return(
                <>
                    {renderInput()}
                </>
            )

        }

        const renderCadastrarButtonSimpleView = () => {
            if(this.props.simpleView && this.props.enableCadastrarButtonInSimpleView){
                return (
                    <>
                        <TooltipButton
                            tooltip="Cadastrar Tipo de Recebimento"
                            style={{marginLeft: '15px', maxWidth: '20px', maxHeight: '20px'}}
                            icon="pi pi-plus"
                            onClick = {() => this.setState({displayCadastroTipoDeRecebimentoDialog: true})}
                        />
                    </>
                )
            }
        }         

        const renderSelect = () => {
            return (

                // <div>
                <div className='col-md-12'>

                    <div className='row'>
                        <label style={{ display: 'block' }}>Tipo de Recebimento</label>
                        {renderCadastrarButtonSimpleView()}
                    </div>
                
                    <div className='row'>
                        <Dropdown
                            className={this.props.error ? ConstantsUtil.primereactInputErrorClass : ""}
                            value={this.state.selectedTipoDeRecebimentoIdSimpleView}
                            options={this.state.tiposDeRecebimentoSelectList}
                            onChange={this.handleTipoDeRecebimentoChangeSelectList}
                            optionLabel="label"
                            filter
                            showClear
                            style={{width: '100%'}}
                            filterBy="label"
                            placeholder="Selecione"
                            emptyMessage=""
                            emptyFilterMessage=""
                        />
                        <small className="p-error">{this.props.error ? "Selecione o Tipo de Recebimento" : ""}</small>
                    </div>

                    {/* {renderCreateTipoDePagamentoDialogSimpleView()} */}

                </div>


            )
        }

        const renderInput = () => {
            return (
                <>
                <label htmlFor="tipoDeRecebimento">{this.generateLabel()}</label>
                <input style={{color: '#000'}} type="text"
                                className={"form-control " + this.props.inputTipoDeRecebimentoErrorClass}
                                readOnly
                                value = {this.props.selectedTipoDeRecebimentoLabel}
                                name="selectedTipoDeRecebimentoLabel"
                                id="selectedTipoDeRecebimentoLabel"
                                onClick={this.inputClick}
                                onKeyPress={this.handleKeyPress}
                                placeholder="Nenhum Tipo de Recebimento Selecionado..."
                                disabled={this.props.disabled}
                />
                <div className="invalid-feedback">Escolha o Tipo de Recebimento</div> 
                </>
            )
        }

        const renderHTMLFormat = () => {
            if(this.props.noHTMLFormat){
                return (
                    <>
                    {handleView()}
                    </>
                )
            }
            else {
                return (
                    <>
                    {/* <div className="row"> */}
                    <div className="col-md-4">
                    {handleView()}
                    </div>
                    {/* </div> */}
                    </>
                )
            }
        }

        const renderCreateTipoDeRecebimentoSimplesDialog = () => {
            return(
                <CadastrarTipoDeRecebimentoSimplesDialog
                    visible={this.state.displayCadastroTipoDeRecebimentoDialog}
                    hideDialog={this.hideCreateTipoDeRecebimentoDialog}
                    search={this.searchTiposDeRecebimento}
                />                
            )
        }

        const renderDialog = () => {
                return (
                    <ChooseTipoDeRecebimentoDialog
                        header={this.generateLabel()}
                        visible={this.state.chooseTipoDeRecebimentoDialogVisible || this.props.forceShowDialog}
                        list={this.props.tipoDeRecebimentoList}
                        contaBancariaId={this.props.contaBancariaId}
                        hideDialog={this.hideTipoDeRecebimentoDialog}
                        handleSelectionTipoDeRecebimentoChange={this.handleSelectionTipoDeRecebimentoChange}
                        fromOFX={this.props.fromOFX}
                        showSimpleCreateButton={this.props.showSimpleCreateButton}
                    />
                )
        }

        return(
            <>
                {/* <div className="col-md-4">
                   
                    </div> */}
                {renderHTMLFormat()}

                {renderDialog()}

                {renderCreateTipoDeRecebimentoSimplesDialog()}

            </>
        )

    }

}

export default InputChooseTipoDeRecebimento